import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Ĵus elkoviĝis la Kokido, kaj tuj ricevis riproĉon pro la rompo de l’ ovo. 
      Flavbekulo, sed jam huligano. 
      Evidente, la genetika manko…
    </p>
    `
  )
}

const itemName = {
  esp: 'Neojala kokido'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;